module.exports = __webpack_public_path__ + "img/television2.fba6a153.png";